import React from 'react';

export default function Highlight({ children, style = {}, className = '' }) {
  return (
    <span
      className={`!sm:pt-0 bg-therablue px-1 !pt-[1px] sm:pb-[1px] ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        color: '#fff',
        borderRadius: 8,
        margin: 0,
        verticalAlign: 'middle',
        boxDecorationBreak: 'clone',
        WebkitBoxDecorationBreak: 'clone',
        ...style,
      }}
    >
      {children}
    </span>
  );
}
